import { RouterLink } from '@redux-first-router-link';
import { useTheme, Text } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';
import { useMyScreeners } from '../hooks/useMyScreeners';
import { Link, LockIcon, SmallBadge } from '../styled';

type TableRowType = ReturnType<
  typeof useMyScreeners
>['data']['predefinedUserScreenerSummary'][number];

export const TableRowScreenerUser = ({
  name,
  id,
  isLimited,
  newCompaniesTotalHits,
}: TableRowType) => {
  const theme = useTheme();
  const { trackEvent } = useTracking();
  const url = `/screener/edit/user/${id}/${name}`;

  const handleTracking = () => {
    trackEvent({
      action: 'click',
      modifier: 'list_item',
      screenerId: id,
      screenerName: name,
      newCompanyCount: newCompaniesTotalHits,
      isLimited,
    });
  };

  return (
    <tr data-cy-id="my-screeners-item-user">
      <td>
        <RouterLink to={url} onClick={handleTracking}>
          <Text
            typography="tiny"
            as="span"
            style={{ display: 'block' }}
            isTruncated
          >
            {name}
          </Text>
        </RouterLink>
      </td>
      <td>
        <Link to={url} onClick={handleTracking}>
          {isLimited ? (
            <LockIcon
              aria-label="Limited Screener"
              fill={theme.color.chart05}
            />
          ) : (
            <SmallBadge
              tone={(newCompaniesTotalHits ?? 0) > 0 ? 'attention' : undefined}
            >
              {newCompaniesTotalHits ?? '0'} New
            </SmallBadge>
          )}
        </Link>
      </td>
    </tr>
  );
};
